import TwoOptionsWouldYouRatherQuiz from "../QuizTypes/TwoOptionsWouldYouRatherQuiz";
import ThreeOptionsWouldYouRatherQuiz from "../QuizTypes/ThreeOptionsWouldYouRatherQuiz";
import MysteryWouldYouRatherQuiz from "../QuizTypes/MysteryWouldYouRatherQuiz";
import TwoOptionsCorrectAnswerQuiz from "../QuizTypes/TwoOptionsCorrectAnswerQuiz";
import ChooseYesOrNoButtonQuiz from "../QuizTypes/ChooseYesOrNoButtonQuiz";
import GuessTheCharacterByVoiceQuiz from "../QuizTypes/GuessTheCharacterByVoiceQuiz";
import FromCharacterToAiPhotoQuiz from "../QuizTypes/FromCharacterToAiPhotoQuiz";
import GuessByEmojiQuiz from "../QuizTypes/GuessByEmojiQuiz";
import NeverHaveIEverQuiz from "../QuizTypes/NeverHaveIEverQuiz";
import TestYourKnowledgeQuiz from "../QuizTypes/TestYourKnowledgeQuiz";
import ChooseYourGiftQuiz from "../QuizTypes/ChooseYourGiftQuiz";

const QuizImplementor = ({selectedType, quizStructure, onCreateQuiz, quizId, channel}) => {
    return (
        <>
        {selectedType === "WouldYouRather" && quizStructure && (
            <TwoOptionsWouldYouRatherQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "ThreeOptionsWouldYouRather" && quizStructure && (
            <ThreeOptionsWouldYouRatherQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "MysteryWouldYouRather" && quizStructure && (
            <MysteryWouldYouRatherQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "TwoOptionsCorrectAnswer" && quizStructure && (
            <TwoOptionsCorrectAnswerQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "ChooseYesOrNoButton" && quizStructure && (
            <ChooseYesOrNoButtonQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "GuessTheCharacterByVoice" && quizStructure && (
            <GuessTheCharacterByVoiceQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "FromCharacterToAiPhoto" && quizStructure && (
            <FromCharacterToAiPhotoQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "GuessByEmoji" && quizStructure && (
            <GuessByEmojiQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "NeverHaveIEver" && quizStructure && (
            <NeverHaveIEverQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "TestYourKnowledge" && quizStructure && (
            <TestYourKnowledgeQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        {selectedType === "ChooseYourGift" && quizStructure && (
            <ChooseYourGiftQuiz
            quizId={quizId}
            backendQuizData={quizStructure}
            onCreateQuiz={onCreateQuiz}
            channel={channel}
            />
        )}
        </>
    )
}

export default QuizImplementor